import {
  DesktopOutlined,
  FolderOutlined,
  LoginOutlined,
  LogoutOutlined,
  PieChartOutlined
} from '@ant-design/icons'
import { Layout, Menu } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { ADMIN_AUTH_TOKEN, AUTH_TOKEN } from '~/utils/constants'
import { useLogoutMutation } from '../mutations'
import './styles.scss'
import { useCallback } from 'react'
const { Sider } = Layout

const SideBar = ({ ...props }) => {
  const { mutate } = useLogoutMutation()
  const location = useLocation()
  const key = location?.pathname.split('/')

  const adminToken = localStorage.getItem(ADMIN_AUTH_TOKEN)
  const backToAdmin = useCallback(() => {
    localStorage.setItem(AUTH_TOKEN, adminToken)
    localStorage.removeItem(ADMIN_AUTH_TOKEN)
    window.location.reload()
  }, [adminToken])

  return (
    <Sider collapsible className="PageSider" {...props}>
      <div className="logo" />
      <Menu theme="dark" defaultSelectedKeys={[key[2]]} mode="inline" items={[
        {
          key: 'courses',
          label: <Link to="courses">Events</Link>,
          icon: <PieChartOutlined />
        },
        {
          key: 'cases',
          label: <Link to="cases">Cases</Link>,
          icon: <FolderOutlined />
        },
        {
          key: 'workstations',
          label: <Link to="workstations">Workstations</Link>,
          icon: <DesktopOutlined />
        },
        {
          key: 'log_out',
          label: 'Log Out',
          icon: <LogoutOutlined />,
          onClick: mutate
        },
        adminToken != null && {
          key: 'backtoadmin',
          label: 'Back to admin',
          icon: <LoginOutlined />,
          style: { fontWeight: 'bold', color: 'white' },
          onClick: backToAdmin
        }
      ]} />
    </Sider>
  )
}

export default SideBar
